//import { en } from "vuetify/src/locale";

export default {
  // ...en,

  welcome: "Welcome to {company}",
  errors: {
    passwordsMustMatch: "Passwords must match and be at least 6 characters",
    allFieldsAreRequired: "All fields are required",
    sendEmailLinkFails:
      "We can't send the email link to sign in, please try later or contact the administrator",
    signInEmailLinkFails:
      "We can't sign in with the email link, please try later or contact the administrator",
    idleLogout: "You have left this browser idle for {0} minutes.",
  },
  success: {
    login: "Login successful",
    sendEmailLink:
      "Email link send successful, please check your email to sign in",
    loginEmailLink: "Login successful we are redirecting to platform",
  },
  token: {
    completeRegistration:
      "Complete the registration in order to accept your invitation",
    completeLogin: "Login to accept your invitation",
  },
  countries: {
    AU: "Australia",
    AT: "Austria",
    BE: "Belgium",
    BR: "Brazil",
    BG: "Bulgaria",
    CA: "Canada",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    EE: "Estonia",
    FI: "Finland",
    FR: "France",
    DE: "Germany",
    GR: "Greece",
    HK: "Hong Kong",
    HU: "Hungary",
    IE: "Ireland",
    IT: "Italy",
    JP: "Japan",
    LV: "Latvia",
    LT: "Lithuania",
    LU: "Luxembourg",
    MY: "Malaysia",
    MT: "Malta",
    MX: "Mexico",
    NL: "Netherlands",
    NZ: "New Zealand",
    NO: "Norway",
    PL: "Poland",
    PT: "Portugal",
    RO: "Romania",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    ES: "Spain",
    SE: "Sweden",
    CH: "Switzerland",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
  },
  common: {
    thanksForJoining: "We're happy you joined {0}!",
    pleaseVerifyEmail:
      "To finish signing up, we have sent you a verification email to confirm that we got your details right.",
    resendVerifyEmail:
      "If you did not receive a verification email, click the button below to resend it.",
    or: "or",
    sendEmailLink: "Send Email Link",
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    resetPassword: "Reset password",
    confirmPassword: "Confirm Password",
    register: "Register",
    firstName: "First Name",
    lastName: "Last Name",
    signup: "Sign Up",
    company: "Company",
    individual: "Individual",
    country: "Country",
    verifyEmail: "Verify Email",
    emailSent: "Email Sent",
    amount: "Amount",
    paymentMethod: "Payment Method",
    submit: "Submit",
    payNow: "Pay Now",
  },
  language: {
    enUS: "English",
    frQC: "French",
    esES: "Spanish",
  },
  customers: {
    createProfile: "Create profile",
    createNewProfile: "Create a new profile",
    myCustomers: "My Profiles",
    selectAProfile: "Select a profile",
    profileOptions: "Profile options",
    emptyProfiles:
      "Looks like there aren't any profiles with your email address in {0}'s system",
    optionMakePayment: "Make a payment",
    optionPaymentHistory: "View Payment history",
    optionManageProfile: "Manage profile",
    inputPaymentInfo:
      "Input the amount of your payment you would like to make towards your {0} account.",
    productName: "Payment",
    name: "Full name",
    proceedToCheckout: "Proceed to checkout",
    successfulPayment: "Your payment was successfully processed",
    fields: {
      description: "Description",
    },
    options: {
      payment: {
        title: "Payment",
      },
      paymentHistory: {
        title: "Payment History",
      },
      paymentDetails: {
        title: "Payment Details",
      },
    },
  },
  chip: {
    status: {
      succeeded: "Success",
      requires_payment_method: "Incomplete",
      requires_confirmation: "Incomplete",
      processing: "Processing",
      canceled: "Canceled",
      failed: "Failed",
    },
  },
  login: {
    title: "Welcome to {company}",
    subtitle: "To begin, login with your ID or create a new one",
    missingAccount: "Don't have an account?",
    sendLinkBtnHint: "",
  },
  register: {
    title: "Create an account",
    subtitle: "Get started on your brand new adventure in {company}",
    haveExistingAccount: "Already have an account?",
  },
  forgotPassword: {
    title: "It happens to the best of us.",
    subtitle:
      "Enter the email for your account and we will send you instructions",
    backTo: "Back to",
    success: "Email to reset password has been sent",
    sent: "We have send a password reset link to the email provided.",
  },
  accounts: {
    locatedIn: "Located in...",
    title: "Hello, {name}",
    subtitle: "",
    errorSubtitle: "",
    myAccounts: "My accounts",
    createVerbose: "Create a new account",
    createShort: "Create account",
    newAccount: "New account",
    iAmA: "I am a ...",
    agreementText:
      "By registering your account, you agree to our ServicesAgreement and the",
    agreementStripeLink: "Stripe Connected Account Agreement.",
    createYourFirstAccount: "Create your first {company} account",
    toBeginInstructions:
      "To begin, click the button below and tell us a bit about you or your company",
    connectedDisclaimer: "This account will be connected to <b>{email}</b>",
    andMyNameIs: "And my name is...",
    andMyCompanyNameIs: "And my company name is...",
    accountCreated: "Account created",
  },
  invoice: {
    date: "Invoice Date",
  },
  payment: {
    newPaymentMethod: "New Payment Method",
    status: {
      partialRefund: {
        label: "Partial refund",
        hint: "{0} was refunded",
        color: "blue lighten-3",
        textColor: "blue darken-4",
        icon: "mdi-information",
        forDetails: "Partially refunded",
      },
      fullRefund: {
        label: "Refunded",
        hint: "This refund has been initiated",
        color: "blue lighten-3",
        textColor: "blue darken-4",
        icon: "mdi-undo-variant",
        forDetails: "Refunded",
      },
      requires_payment_method: {
        label: "Incomplete",
        color: "grey lighten-2",
        textColor: "grey darken-4",
        hint: "Missing payment method information",
        icon: "mdi-clock-time-four",
        forDetails: "Incomplete",
      },
      requires_confirmation: {
        label: "Incomplete",
        color: "grey lighten-2",
        textColor: "grey darken-4",
        hint: "Payment requires confirmation",
        icon: "mdi-clock-time-four",
        forDetails: "Unconfirmed",
      },
      requires_action: {
        label: "Incomplete",
        color: "grey lighten-2",
        textColor: "grey darken-4",
        hint: "An additional action is required to complete this payment; Customer may be required to authenticate using 3D Secure",
        icon: "",
        forDetails: "Unconfirmed",
      },
      processing: {
        label: "Processing",
        color: "info",
        hint: "",
        icon: "mdi-clock-time-four",
        forDetails: "Unconfirmed",
      },
      requires_capture: {
        label: "Incomplete",
        color: "grey lighten-2",
        textColor: "grey darken-4",
        hint: "",
        icon: "mdi-clock-time-four",
        forDetails: "Uncaptured",
      },
      failed: {
        label: "Failed",
        color: "red lighten-4",
        textColor: "red darken-4",
        hint: "",
        icon: "mdi-close",
        forDetails: "Failed",
      },
      canceled: {
        label: "Canceled",
        hint: "Cancellation reason: <code>{0}</code>",
        color: "red lighten-4",
        textColor: "red darken-4",
        icon: "mdi-close",
        forDetails: "Refunded",
        reason: {
          void_invoice: "Void invoice",
          requested_by_customer: "Requested by customer",
          duplicate: "Duplicate",
          fraudulent: "Fraudulent",
          automatic: "Automatic",
        },
      },
      succeeded: {
        label: "Succeeded",
        hint: "This payment is complete",
        color: "green lighten-4",
        textColor: "green darken-4",
        icon: "mdi-check",
        forDetails: "Succeeded",
      },
    },
  },
};
